import { useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import ChatList from "./chatList/ChatList";
import ChatWindow from "./chatWindow/ChatWindow";
import styles from "./usersChat.module.css";

const UsersChat = () => {
  const { activeUserId } = useSelector((state) => state.supportChat);

  return (
    <div className={styles.container}>
      <TextWrapper textStyle="textTitle">شات المستخدمين</TextWrapper>
      <div className={styles.displayContainerWrapper}>
        <DisplayContainer>
          <div className={styles.userChatsWrapper}>
            <div className={styles.availableChatsWrapper}>
              <div className={styles.contentWrapper}>
                <ChatList />
              </div>
            </div>
            <div className={styles.currentChatWrapper}>
              {activeUserId && <ChatWindow />}
            </div>
          </div>
        </DisplayContainer>
      </div>
    </div>
  );
};

export default UsersChat;
